import {Image, View} from "@aws-amplify/ui-react"
import * as React from "react"
import {Link} from "react-router-dom"
import AtNetworkLogo from "../../common/assets/images/at-network-logo.svg"


export default function Logo({height = "100px"}) {
    return <View
        height={ height }
        grow="1"
    >
        <Link to="/">
            <Image
                alt="AT Network logo"
                src={ AtNetworkLogo }
                objectFit="cover"
                paddingLeft="1rem"
                height="100%"
            />
        </Link>
    </View>
}
